module.exports = __webpack_public_path__ + "static/media/pacman_0.29ec7d57.png";